import React from 'react';

const TrustLogos = ({ type }) => {
	return (
		<div
			className={`c-trust-mini-row ${type === 'content' ? 'c-trust-mini-row--content' : ''} ${
				type === 'footer' ? 'c-trust-mini-row--footer' : ''
			}`}
		>
			<div className="c-trust-mini-row__col">
				<a
					href="https://www.google.com/search?q=hear.com+coral+gables&rlz=1C5CHFA_enNI1022NI1022&oq=hear.com+coral&aqs=chrome.0.35i39j69i57j0i390i650l3j69i60.3285j0j4&sourceid=chrome&ie=UTF-8#lrd=0x88d9b79a5d150773:0xd02da6089c76edc7,1"
					target="_blank"
					rel="noopener"
				>
					<img
						className="o-fluid-img"
						src={`https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,q_auto:best/v1/assets/na/seo-website/google${
							type === 'footer' ? '-white' : ''
						}.png`}
						alt="Google reviews"
						loading="lazy"
					/>
				</a>
			</div>
			<div className="c-trust-mini-row__col">
				<a
					href="https://www.bbb.org/us/fl/coral-gables/profile/hearing-assistive-devices/hearcom-llc-0633-90304585"
					target="_blank"
					rel="noopener"
				>
					<img
						className="o-fluid-img"
						src="https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,q_auto:best/v1/assets/na/seo-website/bbb.png"
						alt="Better Business Bureau rated A+"
						loading="lazy"
					/>
				</a>
			</div>
			<div className="c-trust-mini-row__col">
				<div
					className="js-trustpilot-widget"
					data-locale="en-US"
					data-template-id="53aa8807dec7e10d38f59f32"
					data-businessunit-id="5601900f0000ff00058398fb"
					data-style-height="90px"
					data-style-width="100%"
					data-theme={type === 'footer' ? 'dark' : 'light'}
				>
					<a href="https://www.trustpilot.com/review/hear.com" target="_blank" rel="noopener">
						Trustpilot
					</a>
				</div>
			</div>
		</div>
	);
};

export default TrustLogos;
